import React from 'react';
import {
  RecommendationsRow,
  AnyoneCanSellRow,
  TrendingSearches,
  HomepageEmbed,
  Categories,
  Articles,
  NewsletterSignup,
  NewGearRow,
  DealsAndSteals,
  SellYourGear,
  HomepageSearchRecommendations,
  ReverbAppCallout,
  MostWatchedRow,
  BasedOnYourRecentlyViewed,
  JustListed,
} from './logged_out/content_components';

import { useMediaQuery } from '@reverbdotcom/cadence/components';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';

export function DefaultLoggedOutHomepage() {
  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage" ssrMode="full" />
      </div>
      <RecommendationsRow />
      <AnyoneCanSellRow />
      <TrendingSearches />
      <HomepageEmbed />
      <Categories />
      <Articles />
      <NewsletterSignup />
      <NewGearRow />
      <DealsAndSteals />
      <SellYourGear />
    </>
  );
}

export function LoggedOutHomepageRedesign() {
  const isMobile = useMediaQuery('mobile');
  return (
    <>
      <div className="mb-gap-row">
        {
          isMobile ?
            <CmsEmbed slug="logged-out-homepage-redesign" ssrMode="full" />
            :
            <CmsEmbed slug="logged-out-homepage" ssrMode="full" />
        }
      </div>
      <BasedOnYourRecentlyViewed />
      <MostWatchedRow />
      <HomepageSearchRecommendations />
      <CmsEmbed slug="homepage-embed-05-24" ssrMode="off" />
      <JustListed />
      <Categories useRedesign />
      <ReverbAppCallout />
    </>
  );
}

function LoggedOutHomepage() {
  const user = useUser();
  if (isExperimentEnabled(user, experiments.LOGGED_OUT_HOMEPAGE_REDESIGN_V2)) {
    return <LoggedOutHomepageRedesign/>;
  } else {
    return <DefaultLoggedOutHomepage/>;
  }
}

export default LoggedOutHomepage;
